export const PROJECAO_TITLE = "Projeção financeira";
export const RESUMO_TITLE = "Escopo macro";
/** Campos do resumo na ordem da tela, com o rótulo e o testid prontos. */
export const RESUMO_CAMPOS = [
  { campo: "tipoObra", rotulo: "Tipo de Obra", testId: "adicionar-escopo-resumo-tipoObra" },
  {
    campo: "centroCusto",
    rotulo: "Centro de custo",
    testId: "adicionar-escopo-resumo-centroCusto",
  },
  { campo: "escopo", rotulo: "Escopo macro", testId: "adicionar-escopo-resumo-escopo" },
  { campo: "inicio", rotulo: "Início previsto", testId: "adicionar-escopo-resumo-inicio" },
  { campo: "fim", rotulo: "Fim previsto", testId: "adicionar-escopo-resumo-fim" },
  { campo: "origem", rotulo: "Origem", testId: "adicionar-escopo-resumo-origem" },
] as const;
